import React from 'react'
import { components } from '@sainsburys-tech/bolt-cms-components'

import SeoFooter from './SeoHomepage.styles'

const SeoHomepage = ({ seoFooter }) => {
  if (!seoFooter) {
    return null
  }

  const SeoAccordion = components.M0182

  const seoAccordionProps = {
    type: 'M0182',
    bodyCopy: seoFooter,
    textColor: 'grey-charcoal',
  }

  return (
    <SeoFooter className='container'>
      <SeoAccordion {...seoAccordionProps} />
    </SeoFooter>
  )
}

export default SeoHomepage
